import { ArrowBack } from "@mui/icons-material"
import { Box, Divider, Grid, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { DriverFinancialModel } from "../../models/driverFinancial"
import { TEXT_TITLE_COLOR } from "../../constants/colors"
import useOrderDetailRiderFinancialController from "../driverFinacial/controller/orderDetail"
import TabOrderCashTypeComponents from "./components/tabOrderCash"
import { OrderDriverFinancial } from "../../models/orderDriverFinancial"
import { numberFormat } from "../../utils/nunberFormat"
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global"
import { useTranslation } from "react-i18next"

interface Props {
    onClose: VoidFunction
    selectedData: DriverFinancialModel
}

const OrderDetailView = ({ onClose, selectedData }: Props) => {
    const controller = useOrderDetailRiderFinancialController({ selectedData })
    const { t } = useTranslation('global')

    return (
        <Box>
            <IconButton onClick={onClose}>
                <ArrowBack />
            </IconButton>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                    <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}>{t("clearanceMoney_page.All Order")}</Typography>
                </Box>
            </Box>
            <Box mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 4, background: '#c1fec6', borderRadius: '12px' }}>
                            <Typography variant="h5" color={TEXT_TITLE_COLOR} fontWeight="bold">
                                <span>
                                    {t("clearanceMoney_page.Cash Order")}
                                </span>
                            </Typography>
                            <Typography variant="h6" color={TEXT_TITLE_COLOR} fontWeight="bold">{selectedData?.ordersCash?.orders?.length === undefined ? 0 : selectedData?.ordersCash?.orders?.length}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 4, background: '#ffacb6', borderRadius: '12px' }}>
                            <Typography variant="h5" color={TEXT_TITLE_COLOR} fontWeight="bold">
                                <span>
                                    {t("clearanceMoney_page.Order OnePay")}
                                </span>
                            </Typography>
                            <Typography variant="h6" color={TEXT_TITLE_COLOR} fontWeight="bold">{selectedData?.ordersOnePay?.orders?.length === undefined ? 0 : selectedData?.ordersOnePay?.orders?.length}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ p: 4, background: '#f8f8f8', borderRadius: '12px' }}>
                            <Typography variant="h5" color={TEXT_TITLE_COLOR} fontWeight="bold">
                                <span>
                                    {t("clearanceMoney_page.Return Order")}
                                </span>
                            </Typography>
                            <Typography variant="h6" color={TEXT_TITLE_COLOR} fontWeight="bold">{selectedData?.ordersReturn?.orders?.length === undefined ? 0 : selectedData?.ordersReturn?.orders?.length}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={2}>
                <TabOrderCashTypeComponents value={controller.tabOrderMoney} onChange={controller.handleTabOrderMoneyType} />
            </Box>
            <Box mt={1}>
                <TableContainer>
                    <Table>
                        <TableHead sx={{ background: '#f7f7f7' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.No")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Order No")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.District Rider Got")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Discount Money")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Vat Money")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Total Money Not Include Vat")}</TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>{t("paymentMoney_page.Total Money")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                controller.rows?.map((item: OrderDriverFinancial, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                            {numberFormat(index + 1 + DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1))}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{item?.orderNo}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{item?.distance} ກິໂລເເມັດ</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(item?.totalDiscountPrice)} {t("Kip")}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(item?.totalVatPrice)} {t("Kip")}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(item?.totalNomalPriceNotIncludeVat)} {t("Kip")}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat(item?.totoalWithDeliveryFee)} {t("Kip")}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Divider />
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <Pagination
                        color="primary"
                        page={controller.currentPage}
                        onChange={controller.handleChangePage}
                        count={controller.countPagination}
                    />
                </Box>
            </Box>
        </Box>
    )
}
export default OrderDetailView